export class CommonUrlConfig {
  public static EndPoint = {
    dropDown: {
      page: '/platform/master/lookup/lookupbycategoryname/PAGE',
      Database: '/referencetype/Database',
      DGPJsonMode: '/referencetype/DGPJsonMode',
      tabOrientation: '/platform/master/lookup/lookupbycategoryname/TAB_ORIENTATION'
    },
    notification: {
      post: '/platform/notification/{id}'
    },
    registration: {
      getRegisteredDate: '/registration/getregisteredDate'
    }
  };
}